import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';

import { authService, navService } from '../../Services';

import { setUser, setStatus, setPermissions, setExhibitDiver } from '../../redux/stores/userSlice';
import { setLocalUser, setLocalStatus, setLocalPermissions, setLocalExhibitDiver } from '../../redux/stores/localUserSlice';
import { setId, setParentId, setName, setLogoExt, setModules, setNav, setRemember, setRef, clearFilter } from '../../redux/stores/orgSlice';

import LoginLayout from '../Common/Layouts/LoginLayout';

import {ReactComponent as Loading} from '../../images/icons/General/loading-01.svg';

export const Login = () => {
    const [login, setLogin] = useState();
    const [password, setPassword] = useState();
    const [checkbox, setCheckbox] = useState(false);
    const [loading, setLoading] = useState();
    const [error, setError] = useState();
    const [success, setSuccess] = useState();
    const orgId = useSelector((state) => state.org.id);
    const parentId = useSelector((state) => state.org.parentId);
    const ref = useSelector((state) => state.org.ref);
    const dispatch = useDispatch();
    const [searchParams, setSearchParams] = useSearchParams();

    const handleCheckbox = () => {
        setCheckbox(!checkbox);
    }

    const handleSubmit = async e => {
        e.preventDefault();
        setLoading(true);
        setError(false);

        const user = await authService.login({
            login,
            password,
            orgId,
            parentId
        });

        if (user.hid) {
            dispatch(clearFilter());
            if (checkbox) {
                dispatch(setLocalUser(user));
                dispatch(setRemember(checkbox));
            } else 
                dispatch(setUser(user));

            let org = (user.orgs.length === 1 && user.orgs[0].ustatus === 1) ? user.orgs[0] : (ref && user.orgs.filter(item => item.id === ref)[0].ustatus === 1 ? user.orgs.filter(item => item.id === ref)[0] : 0)
                
            if (org) {
                dispatch(setId(org.id));
                dispatch(setParentId(org.parentId));
                dispatch(setName(org.Name));
                dispatch(setLogoExt(org.LogoFileExt));
                dispatch(setModules(org.modules));
                dispatch(setNav(org.nav ? navService.navJSON(org.nav, org.activityTypes) : navService.defaultNav(org.activityTypes)));
                document.title = org.Name;

                if (checkbox) {
                    dispatch(setLocalPermissions(org.permissions));
                    dispatch(setLocalExhibitDiver(org.exhibitDiver));
                    dispatch(setLocalStatus(org.ustatus));
                } else {
                    dispatch(setPermissions(org.permissions));
                    dispatch(setExhibitDiver(org.exhibitDiver));
                    dispatch(setStatus(org.ustatus));
                }
            }

            if (ref) {
                dispatch(setRef(0));
                searchParams.delete('ref');
                setSearchParams(searchParams);
            }
            
            setLoading(false);
        } else {
            setLoading(false);
            if (user.success) 
                setSuccess(user.success);
            else
                setError(user.error);
        }
    }

    return (
        <LoginLayout>
            <div className="login">
                <h2>Diving Safety Program</h2>
                <p>Welcome back! Please enter your details.</p>

                <form onSubmit={handleSubmit}>
                    <div className="form-control">
                        <label>Email</label>
                        <input type="text" name="login" placeholder="Enter your email" onChange={e => setLogin(e.target.value)} />
                    </div>
                    <div className="form-control">
                        <label>Password</label>
                        <input type="password" name="password" placeholder="Password" onChange={e => setPassword(e.target.value)} />
                    </div>
                    <div className="forgot-password">
                        <div className="checkbox">
                            <input type="checkbox" name="remember" id="remember" checked={checkbox} onChange={handleCheckbox} />
                            <label htmlFor="remember">Remember me</label>
                        </div>
                        <Link to="/reset-password">Forgot password</Link>
                    </div>
                    <button type="submit" className="primary">{loading ? <Loading className="btn-loader" alt="loader" /> : ''}Sign in</button>
                    {error ? <div className="error">{error}</div> : ''}
                    {success ? <div className="success">{success}</div> : ''}
                </form>
                <div className="register">
                    <p>Don’t have an account with an Organizational Member of the American Academy of Underwater Sciences? <Link to="/sign-up">Sign up for a new account.</Link></p>
                    <p>If you're having trouble logging in to an existing account, contact your organizations' Diving Safety Officer for assistance.</p>
                </div>
            </div>
        </LoginLayout>
    );
};

export default Login;